import style from './style.module.scss'
import clsx from 'clsx'

const BurgerMainHeader = ({ open, setOpen }) => {
    const containerClasses = clsx({
        [style.container]: true,
        [style.open]: open,
    })

    return (
        <div className={containerClasses} onClick={() => setOpen((old) => !old)}>
            <div className={style.burger}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className={style.label}>Menu</div>
        </div>
    )
}

export default BurgerMainHeader
